function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#FFF",
  fillRule: "evenodd",
  opacity: 0.5
}, React.createElement("path", {
  d: "M40.665 6h6.67c.616 0 .845-.393.513-.879L44.6.364c-.332-.486-.869-.485-1.2 0l-3.248 4.757c-.332.486-.102.879.513.879zM.665 0h6.67c.616 0 .845.393.513.879L4.6 5.636c-.332.486-.869.485-1.2 0L.152.879C-.18.393.05 0 .665 0z"
}));

var SvgReorder = function SvgReorder(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 6,
    viewBox: "0 0 48 6"
  }, props), _ref);
};

export default "data:image/svg+xml,%3Csvg width='48px' height='6px' viewBox='0 0 48 6' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' opacity='0.5'%3E %3Cg fill='%23FFFFFF'%3E %3Cg%3E %3Cpath d='M40.6650677,0 L47.3348793,0 C47.9507299,0 48.1795115,0.393348919 47.8481997,0.8785694 L44.5998667,5.63589311 C44.2682062,6.12162427 43.7313922,6.12111359 43.4000804,5.63589311 L40.1517474,0.8785694 C39.8200869,0.39283824 40.0502569,0 40.6650677,0 Z' transform='translate(44.000000, 3.000000) scale(1, -1) translate(-44.000000, -3.000000) '%3E%3C/path%3E %3Cpath d='M0.665067729,0 L7.33487934,0 C7.95072985,0 8.17951152,0.393348919 7.84819968,0.8785694 L4.5998667,5.63589311 C4.26820616,6.12162427 3.73139222,6.12111359 3.40008037,5.63589311 L0.151747392,0.8785694 C-0.179913148,0.39283824 0.0502568906,0 0.665067729,0 Z'%3E%3C/path%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgReorder as ReactComponent };